import { environment } from '@/assets/environment';
import { IErrorResponse } from '@/models/errors/error-response.model';
import { IScrewFilter } from '@/models/store/filter-data/screw-filter.model';
import { IHelperScrewData } from '@/models/store/screw/helper-screw-data.model';
import { IScrewState } from '@/models/store/screw/screw-state.model';
import { IScrew } from '@/models/store/screw/screw.model';
import { Module } from 'vuex';

export const screwModule: Module<IScrewState, unknown> = {
    state: {
        screws: [],
        helperScrewsData: {
            brands: [],
            fastenerTypes: [],
            lengths: [],
            threads: [],
            wrenchs: [],
        },
    },

    actions: {
        fetchScrews: async (
            { commit },
            payload: { pageNumber: number; count: number; screwFilter: IScrewFilter },
        ): Promise<void> => {
            const params = new URLSearchParams();
            params.append('pageNumber', `${payload.pageNumber}`);
            params.append('count', `${payload.count}`);
            if (payload.screwFilter.typeName)
                params.append('typeName', payload.screwFilter.typeName);
            if (payload.screwFilter.brand) params.append('brand', payload.screwFilter.brand);
            if (payload.screwFilter.fastenerType)
                params.append('fastenerType', payload.screwFilter.fastenerType);
            if (payload.screwFilter.length) params.append('length', payload.screwFilter.length);
            if (payload.screwFilter.thread) params.append('thread', payload.screwFilter.thread);
            if (payload.screwFilter.wrench) params.append('wrench', payload.screwFilter.wrench);

            const response = await fetch(`${environment.baseUrl}/api/screw?` + params, {
                method: 'get',
                headers: {
                    'x-app': 'secret_admin',
                    'Content-type': 'application/json',
                },
            });

            if (!response.ok) {
                const errorObject: IErrorResponse = await response.json();
                commit('setSnackbarState', {
                    status: true,
                    text: errorObject.error,
                    isError: true,
                });
                return;
            }

            const data = await response.json();
            commit('setPaginationLength', data.length);
            commit('setScrews', data.data);
        },

        fetchHelperScrewData: async ({ commit }) => {
            const response = await fetch(`${environment.baseUrl}/api/helper-screw`, {
                method: 'get',
                headers: {
                    'x-app': 'secret_admin',
                    'Content-type': 'application/json',
                },
            });

            if (!response.ok) {
                const errorObject: IErrorResponse = await response.json();
                commit('setSnackbarState', {
                    status: true,
                    text: errorObject.error,
                    isError: true,
                });
                return;
            }

            const filterData = (await response.json()).data;
            commit('setScrewHelperData', filterData);
        },
    },

    mutations: {
        setScrews: (store, payload: IScrew[]): void => {
            store.screws = [...payload];
        },
        setScrewHelperData: (store, payload: IHelperScrewData): void => {
            store.helperScrewsData = { ...payload };
        },
    },

    getters: {
        getScrews: (store) => store.screws,
        getHelperScrewData: (store) => store.helperScrewsData,
    },
};
